import ModuleCard from './ModuleCard.vue';

export default ModuleCard;



// WEBPACK FOOTER //
// ./src/pages/modules/card/index.ts